import { Button } from '@carvana/helios-navigation/button';
import Link from 'next/link';
import { EventActions } from '../../../analytics/uiMetrics';
import useAnalyticEvent, { PageName } from '../../../hooks/useAnalyticEvent';
import { APP_BASE_PATH } from '../../../shared/appBasePath';

import { GetValueContainer, Heading } from './GetValueModule.styles';

const getValueRoute = `${APP_BASE_PATH}/get-value/vehicle`;

const GetValueModule = () => {
  const { recordEventAndNavigate } = useAnalyticEvent();

  const ctaText = 'Get Your Value';

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.currentTarget.href = getValueRoute;
    recordEventAndNavigate(e, PageName.Marketing, 'Value Module', {
      event: EventActions.Clicked
    });
  };

  return (
    <GetValueContainer>
      <Heading>See how your value compares to similar vehicles</Heading>
      <Link href={getValueRoute} onClick={handleClick} prefetch={false}>
        <Button variant="primaryInverted" as="div">
          {ctaText}
        </Button>
      </Link>
    </GetValueContainer>
  );
};

export default GetValueModule;
